import * as i0 from "@angular/core";
var SessionStorageService = /** @class */ (function () {
    function SessionStorageService() {
    }
    SessionStorageService.prototype.getItem = function (key, convertToJSON) {
        var data = sessionStorage.getItem(key);
        if (convertToJSON) {
            try {
                data = JSON.parse(data);
            }
            catch (e) { }
        }
        return data;
    };
    SessionStorageService.prototype.setItem = function (key, data, convertToString) {
        var dataLocal = data;
        try {
            if (convertToString) {
                dataLocal = JSON.stringify(dataLocal);
            }
            sessionStorage.setItem(key, dataLocal);
        }
        catch (e) { }
    };
    SessionStorageService.prototype.removeItem = function (key) {
        sessionStorage.removeItem(key);
    };
    SessionStorageService.prototype.clear = function () {
        sessionStorage.clear();
    };
    SessionStorageService.ngInjectableDef = i0.defineInjectable({ factory: function SessionStorageService_Factory() { return new SessionStorageService(); }, token: SessionStorageService, providedIn: "root" });
    return SessionStorageService;
}());
export { SessionStorageService };
